export const UIFormatSSN = (SSN: string): string => {
	if (SSN.includes("@")) return SSN.replaceAll("@", "");

	return SSN;
};

export const hideSSN = (SSN: number): string => {
	let hiddenSSN = "XXX-XX-";
	const strSSN = String(SSN);

	for (let idx = 5; idx < strSSN.length; idx++) {
		hiddenSSN = hiddenSSN + strSSN[idx];
	}

	return UIFormatSSN(hiddenSSN);
};

export const formatSSN = (SSN: string): string => {
	return SSN.substring(0, 3) + "-" + SSN.substring(3, 5) + "-" + SSN.substring(5);
};

// export const handleSSNFormat = (user: any, SSN: string): string => {
// 	console.log("checkingthis-->", SSN);
// 	if (!SSN) return "";
// 	const lastFour = SSN.slice(-4);
// 	return `XXX-XX-${lastFour}`;
// };
